import { styled } from "../../../../styles";

// Matches the ECG/measurement modal content: title + range header at the top,
// table filling the remaining height (so the empty state centers vertically).
export const ModalContainer = styled("div", {
  height: "100%",
  width: "100%",
  padding: "24px 0 0 0",

  display: "flex",
  flexDirection: "column",
});

// Pull flush against the modal edges (the modal has 24px left padding), so the
// table spans full width like the ECG/measurement tables.
export const TableContainer = styled("div", {
  width: "calc(100% + 24px)",
  marginLeft: "-24px",
  fontSize: "14px",

  flex: 1,
  minHeight: 0,
});
